import { useEffect, useRef, useState } from 'react';

import styles from './fullscreen-expand.module.css';

export function useFullscreenExpand<E extends HTMLElement>(
  { initialState } = { initialState: false },
) {
  const expandRef = useRef<E | null>(null);
  const [isExpanded, setUseExpanded] = useState(initialState);

  useEffect(() => {
    if (!expandRef.current) return;

    isExpanded
      ? expandRef.current.classList.add(styles.fullScreenExpand)
      : expandRef.current.classList.remove(styles.fullScreenExpand);
  }, [isExpanded]);

  const toogleExpand = () => {
    if (!expandRef.current) return;
    setUseExpanded((prev) => !prev);
  };

  return { expandRef, toogleExpand, isExpanded } as const;
}
